module.exports = __webpack_public_path__ + "static/media/HCMM902.6dca22bf.jpg";